package com.ai.mitra

import kotlin.String

public data class GroupChat(
  public val groupId: String,
  public val title: String,
  public val date: String,
  public val image: String,
)
